import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetFiveStars, GetFiveStarsModel, GetFiveStarsParams} from 'domain/usecases';

export class RemoteGetFiveStars implements GetFiveStars {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetFiveStarsModel>,
	) {}

	async get(params?: GetFiveStarsParams): Promise<GetFiveStarsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal: params?.signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
